const LRS = (str, m = str.length, n = str.length) => {
  // If there are no more characters in the string to evaluate
  if (m === 0 || n === 0) {
    return 0;
  }

  // incase characters at index m and n are same
  // but the index of the character are different
  if (str[m - 1] === str[n - 1] && m !== n) {
    return LRS(str, m - 1, n - 1) + 1;
  }

  // else, return the max of the lrs at different indexes.
  return Math.max(LRS(str, m, n - 1), LRS(str, m - 1, n));
};

export default LRS;
